module.exports = __webpack_public_path__ + "img/singapore.5c279593.svg";